import type { CashMovementType, PaymentKind } from '@barbeiropro/contracts';

export const KIND_LABEL: Record<PaymentKind, string> = {
  cash: 'Dinheiro',
  pix: 'Pix',
  credit_card: 'Cartão de crédito',
  debit_card: 'Cartão de débito',
  other: 'Outros',
};
export const KIND_ORDER: PaymentKind[] = ['cash', 'pix', 'credit_card', 'debit_card', 'other'];

export const MOVEMENT_LABEL: Record<CashMovementType, string> = {
  opening: 'Abertura',
  payment: 'Recebimento',
  refund: 'Estorno',
  withdrawal: 'Sangria',
  deposit: 'Suprimento',
  adjustment: 'Ajuste',
  expense: 'Despesa',
};

export const EXPENSE_CATEGORIES = ['Aluguel', 'Energia', 'Água', 'Produtos', 'Equipamentos', 'Marketing', 'Impostos', 'Salários', 'Outros'];

export const COMMISSION_STATUS_LABEL = { pending: 'Pendente', paid: 'Paga', reversed: 'Estornada' } as const;

/** Valor com sinal explícito para movimentos de caixa. */
export function signed(cents: number, fmt: (c: number) => string) {
  return `${cents > 0 ? '+' : cents < 0 ? '-' : ''}${fmt(Math.abs(cents))}`;
}
